import { i18n } from 'core/i18n';
const { formatText } = i18n;
import { CREDIT_CARD, OWN_ACCOUNT, PENSIONER, RENTIER, SALARIED } from 'constants/userProfile';
import { NO_ACTIVITY } from 'constants/userProfile';
import { CLIENT_RISK } from 'constants/clientRisk';

const { LOW } = CLIENT_RISK;

export const createTitleFileUploadBox = ({
    accountType,
    clientRisk,
    fileId,
    filesInfoObj,
    investmentType,
    isColectivos,
    isJointHolder,
}) => {
    const UploadBoxTitleAndDescriptionByTypeMap = {
        dni_front: () => {
            return { docTitle: formatText('contentStepsTitles-documentFront') };
        },
        dni_back: () => {
            return { docTitle: formatText('contentStepsTitles-documentBack') };
        },
        refugee: () => {
            return { docTitle: formatText('contentStepsTitles-documentRefugee') };
        },
        nie_front: () => {
            return { docTitle: formatText('contentStepsTitles-NIEFront') };
        },
        permit_front: () => {
            return { docTitle: formatText('contentStepsTitles-permitFront') };
        },
        permit_back: () => {
            return { docTitle: formatText('contentStepsTitles-permitBack') };
        },
        passport_front: () => {
            return { docTitle: formatText('contentStepsTitles-passport') };
        },
        passport_back: () => {
            return { docTitle: formatText('contentStepsTitles-passportBack') };
        },
        daal_nomina_pension: () => {
            return { docTitle: formatText('contentStepsTitles-lastNominaOrPension') };
        },
        permit_nomina: () => {
            return { docTitle: formatText('contentStepsTitles-lastNominaOrPension') };
        },
        permit_pension: () => {
            return { docTitle: formatText('contentStepsTitles-lastNominaOrPension') };
        },
        transfer_certificate: () => {
            return { docTitle: formatText('contentStepsTitles-transferCertificateTitle') };
        },
        recibo: () => {
            if (investmentType === CREDIT_CARD) {
                const ACCOUNTS_TYPES_DAAL_MSG = {
                    [RENTIER]: formatText('contentStepsTitles-addressVerificationTitleRentier_TC'),
                    [PENSIONER]: formatText('contentStepsTitles-addressVerificationTitlePensioner_TC'),
                    [OWN_ACCOUNT]: formatText('contentStepsTitles-addressVerificationTitleOwnAccount_TC'),
                    [SALARIED]: formatText('contentStepsTitles-addressVerificationTitleSalaried_TC'),
                };

                return { docTitle: ACCOUNTS_TYPES_DAAL_MSG[filesInfoObj.accountType] };
            }

            return { docTitle: formatText('contentStepsTitles-addressVerificationTitle') };
        },
        daal: () => {
            if (isColectivos() && !isJointHolder) {
                return { docTitle: formatText('contentStepsTitles-nomina') };
            }

            if (investmentType === CREDIT_CARD) {
                const ACCOUNTS_TYPES_DAAL_MSG = {
                    [RENTIER]: formatText('contentStepsTitles-creditCardRevenueDocumentRentier'),
                    [PENSIONER]: formatText('contentStepsTitles-creditCardRevenueDocumentPensioner'),
                    [OWN_ACCOUNT]: formatText('contentStepsTitles-creditCardRevenueDocumentOwnAccount'),
                    [SALARIED]: formatText('contentStepsTitles-creditCardRevenueDocumentSalaried'),
                };

                return { docTitle: ACCOUNTS_TYPES_DAAL_MSG[filesInfoObj.accountType] };
            }

            if (accountType === NO_ACTIVITY && clientRisk !== LOW) {
                return { docTitle: formatText('contentStepsTitles-proof') };
            }

            return { docTitle: formatText('contentStepsTitles-accreditationRevenue') };
        },
    };

    return UploadBoxTitleAndDescriptionByTypeMap[fileId]();
};
